module.exports = __webpack_public_path__ + "img/west-ham-united.5bb45afe.png";